export default __webpack_public_path__ + "static/media/MidStance.57fdf9c3.png";